var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3890",
    "data-name": "Rectangle 3890",
    width: 29.048,
    height: 29.032,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13251",
    "data-name": "Group 13251",
    transform: "translate(-4184.481 -9430.368)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3891",
    "data-name": "Rectangle 3891",
    width: 32,
    height: 32,
    transform: "translate(4184.481 9430.368)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13250",
    "data-name": "Group 13250",
    transform: "translate(4185.957 9431.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13249",
    "data-name": "Group 13249",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42380",
    "data-name": "Path 42380",
    d: "M17.025,29.032a1.522,1.522,0,0,1-.684-.785q-2.465-5.106-4.951-10.2a.927.927,0,0,0-.4-.4Q5.831,15.131.662,12.634c-.607-.294-.833-.8-.525-1.268A1.268,1.268,0,0,1,.7,10.934q4.927-1.991,9.863-3.957L27.624.156c.73-.292,1.038-.192,1.424.464v.454c-.046.1-.1.2-.137.3Q23.537,14.8,18.169,28.226a1.278,1.278,0,0,1-.69.806Zm7.55-25.816-21.6,8.64L11.7,16.087,24.575,3.216M17.188,26.065l8.625-21.56L12.964,17.355l4.224,8.711",
    transform: "translate(0 0)",
    fill: "#1a1818"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.4bc5942b.svg";
export { ForwardRef as ReactComponent };